(function() {
  function getBasePrice() {
    var selectedId = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId;
    var urlVariant = new URLSearchParams(window.location.search).get('variant');
    var variantId = urlVariant || selectedId;
    var variants = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.variants) || [];
    var variant = variants.find(function(v) { return String(v.id) === String(variantId); });
    var price = (variant && variant.price) || (variants[0] && variants[0].price);
    return price ? price / 100 : null;
  }

  var isUpdating = false;

  function updateVolumeTable() {
    if (isUpdating) return;
    isUpdating = true;

    var basePrice = getBasePrice();
    if (!basePrice) { isUpdating = false; return; }

    var converted = false;
    document.querySelectorAll('.hulkapps-price').forEach(function(span) {
      var text = span.textContent.trim();
      var pctMatch = text.match(/^(\d+(?:\.\d+)?)%/);
      if (pctMatch) {
        var pct = parseFloat(pctMatch[1]);
        span.textContent = '$' + (basePrice * (1 - pct / 100)).toFixed(2);
        converted = true;
      }
    });

    if (converted) {
      document.querySelectorAll('.hulkapps-table th').forEach(function(th) {
        if (th.textContent.indexOf('Percent Saved') !== -1) {
          th.textContent = 'Your Price:';
        }
      });
    }

    isUpdating = false;
  }

  setTimeout(updateVolumeTable, 500);
  setTimeout(updateVolumeTable, 1500);
  setTimeout(updateVolumeTable, 3000);

  function hookHulkapps() {
    if (window.hulkapps_jQuery) {
      hulkapps_jQuery(document).ajaxComplete(function() {
        setTimeout(updateVolumeTable, 100);
      });
    }
  }
  hookHulkapps();
  setTimeout(hookHulkapps, 1000);

  var observer = new MutationObserver(function() {
    var firstPrice = document.querySelector('.hulkapps-price');
    if (firstPrice && /^\d+(\.\d+)?%/.test(firstPrice.textContent.trim())) {
      setTimeout(updateVolumeTable, 50);
    }
  });
  var startObserver = function() {
    var hulkTable = document.querySelector('.hulkapps-table');
    if (hulkTable) observer.observe(hulkTable, { childList: true, subtree: true, characterData: true });
  };
  setTimeout(startObserver, 1000);

  var lastUrl = location.href;
  setInterval(function() {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      setTimeout(updateVolumeTable, 300);
    }
  }, 200);
})();
